module.exports = __webpack_public_path__ + "img/Mastercard.55c42d54.svg";